import styled, { css } from 'styled-components';

import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

import { BaseWidgetActions } from './BaseWidgetActions';

export const Container = styled.div<{ $background: string }>`
  display: flex;
  flex-direction: column;
  background: ${(props) => props.$background};
  border-radius: 4px;
  z-index: 10;
`;

export const Header = styled.div<{ $noBorder: boolean }>`
  display: flex;
  gap: 6px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 8px 12px;
  min-height: 42px;
  border-radius: 4px 4px 0 0;

  ${(props) =>
    !props.$noBorder &&
    css`
      border: 1px solid ${ct({ Dark: Colors.Light, Light: Colors.Light })};
      border-bottom: none;
    `}

  &:hover {
    ${BaseWidgetActions} {
      display: flex;
    }
  }
`;

export const TitleWrapper = styled.div`
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
`;

export const Title = styled.div`
  overflow: hidden;
  flex: 1;
`;

export const Content = styled.div<{ $noPadding: boolean; $noBorder: boolean; $noOverflow: boolean }>`
  flex: 1;
  border-top: none;
  border-radius: 0 0 4px 4px;

  ${(props) =>
    !props.$noPadding &&
    css`
      padding: 12px;
    `};

  ${(props) =>
    !props.$noBorder &&
    css`
      border: 1px solid ${ct({ Dark: Colors.Light, Light: Colors.Light })};
    `}

  ${(props) =>
    !props.$noOverflow &&
    css`
      overflow: auto;
    `};
`;
